<script setup lang="ts">
import { Head } from "@inertiajs/vue3"
import { SbList } from "@unio/saltbox-ui"

import ContainerRow from "@/components/ContainerRow.vue"
import DashboardSectionHeader from "@/components/dashboard/DashboardSectionHeader.vue"
import DashboardStatCards from "@/components/dashboard/DashboardStatCards.vue"
import ListItemRow from "@/components/ListItemRow.vue"
import { useNavbar } from "@/composables/useNavbar"
import { ICON } from "@/lib/icons"
import type { ContainerSummary, ItemSummary } from "@/types/models"

const { title } = useNavbar({ title: "Dashboard (prototype)" })

const stats = [
  { title: "Items", icon: ICON.item, value: 48, subtitle: "+3 today" },
  { title: "Containers", icon: ICON.container, value: 25 },
  { title: "To Catalog", icon: ICON.toCatalog, value: 43 },
]

const recentContainers: ContainerSummary[] = [
  {
    id: "1",
    name: "Thunderbolt and Apple Cables",
    location_path: "My House > Basement Hallway > 3-Tier Metal Rolling Cart 01",
    thumb_url: "https://picsum.photos/seed/cables/80/80",
    inventory_progress: null,
    inventoried_at: null,
  },
  {
    id: "2",
    name: "Network Cables",
    location_path: "My House > Basement Hallway > Wire Shelf Rack 01",
    thumb_url: "https://picsum.photos/seed/network/80/80",
    inventory_progress: null,
    inventoried_at: null,
  },
  {
    id: "3",
    name: "Notepads Sticky Notes Index Cards",
    location_path: "My House > Basement Hallway > Wire Shelf Rack 01",
    thumb_url: "https://picsum.photos/seed/notepads/80/80",
    inventory_progress: null,
    inventoried_at: null,
  },
  {
    id: "4",
    name: "Tape",
    location_path: "My House > Basement Hallway > Wire Shelf Rack 01",
    thumb_url: "https://picsum.photos/seed/tape/80/80",
    inventory_progress: null,
    inventoried_at: null,
  },
  {
    id: "5",
    name: "Drill Bits and Accessories",
    location_path: "My House > Workshop > Pegboard Wall",
    thumb_url: "https://picsum.photos/seed/drills/80/80",
    inventory_progress: null,
    inventoried_at: null,
  },
]

const recentItems: ItemSummary[] = [
  {
    id: "1",
    name: "Kill A Watt Power Meter",
    parent_name: "Power / Solar",
    thumb_url: "https://picsum.photos/seed/killawatt/80/80",
    quantity: 1,
    inventoried_at: "2026-03-30T00:00:00Z",
    location_path: null,
    item_type_name: "Electronics",
    tags: [],
  },
  {
    id: "2",
    name: "EcoFlow Portable Power Station",
    parent_name: "Basement Hallway",
    thumb_url: "https://picsum.photos/seed/ecoflow/80/80",
    quantity: 1,
    inventoried_at: "2026-03-30T00:00:00Z",
    location_path: null,
    item_type_name: "Electronics",
    tags: [],
  },
  {
    id: "3",
    name: "Fellowes 79Ci Shredder",
    parent_name: "Basement Hallway",
    thumb_url: "https://picsum.photos/seed/shredder/80/80",
    quantity: 1,
    inventoried_at: "2026-03-30T00:00:00Z",
    location_path: null,
    item_type_name: "Electronics",
    tags: [],
  },
  {
    id: "4",
    name: "Guitar Patch Cable",
    parent_name: "Wire Shelf Rack 01",
    thumb_url: "https://picsum.photos/seed/guitar/80/80",
    quantity: 1,
    inventoried_at: "2026-03-30T00:00:00Z",
    location_path: null,
    item_type_name: "Music",
    tags: [],
  },
  {
    id: "5",
    name: "Direct Sound EX-29 Headphone",
    parent_name: "Headphones",
    thumb_url: "https://picsum.photos/seed/headphone/80/80",
    quantity: 1,
    inventoried_at: null,
    location_path: null,
    item_type_name: "Audio",
    tags: [],
  },
]
</script>

<template>
  <Head :title="title" />

  <DashboardStatCards :stats="stats" />

  <!-- Lists: side by side on desktop, stacked on mobile -->
  <div class="grid grid-cols-1 gap-4 sm:gap-6 lg:grid-cols-2">
    <div>
      <DashboardSectionHeader title="Recent Containers" to="/containers" />
      <SbList bordered separator>
        <ContainerRow
          v-for="container in recentContainers"
          :key="container.id"
          :container="container"
        />
      </SbList>
    </div>

    <div>
      <DashboardSectionHeader title="Recently Modified" to="/items" />
      <SbList bordered separator>
        <ListItemRow v-for="item in recentItems" :key="item.id" :item="item" />
      </SbList>
    </div>
  </div>
</template>
